module.exports = __webpack_public_path__ + "img/za.bb194490.svg";